import { Directive, ElementRef, Renderer2, forwardRef, Input, OnInit, OnChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PlessInputTextDirective } from '../../shared/input/pless-input-text.directive';
import { PlessViewUtilsSub } from './pless-view-utils-sub.service';

import * as Encoding from 'encoding-japanese';
/**
 * Plessテキスト入力(入力制限機能付き)
 *
 * @export PlessInputTextSubDirective
 * @class PlessInputTextSubDirective
 * @extends {PlessInputTextDirective}
 */
@Directive({
  selector: 'input[plessInputTextSub],textarea[plessInputTextSub]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PlessInputTextSubDirective),
      multi: true
    },
  ]
})

export class PlessInputTextSubDirective extends PlessInputTextDirective implements OnInit, OnChanges  {

  /** 改行を許すかどうかのフラグ */
  @Input() allowMultiLine = true;

  /** アルファベット 大文字変換フラグ */
  @Input() toUpperCase: boolean = <boolean>false;

  /** 非活性フラグ */
  @Input() disabled: boolean = <boolean>false;

  constructor(protected elementRef: ElementRef, protected renderer: Renderer2) {
    super(elementRef, renderer)
  }

  ngOnInit() {
    this.elementRef.nativeElement.disabled = this.disabled;
    super.ngOnInit();
  }

  ngOnChanges() {
    this.elementRef.nativeElement.disabled = this.disabled;
    super.ngOnChanges();
  }

  /**
   * 入力制限処理
   */
  protected doRestrict(value: string) {
    let resultValue = value;
    let resultIndex = this.elementRef.nativeElement.selectionStart;

    // 改行文字を除去する
    if (!this.allowMultiLine) {
      let reqValue = value.replace(/^(\n|\r|\0|\x0B)*/gm, '').replace(/(\n|\r|\0|\x0B)*$/gm, '');
      reqValue = reqValue.replace(/(\n|\r|\0|\x0B)*/gm, '');
      reqValue = reqValue.replace('\r', '');
      reqValue = reqValue.replace('\n', '');

      resultValue = reqValue;
    }

    // 文字を削除した場合は削除後の値を適応
    if (value !== resultValue) {
      this.elementRef.nativeElement.value = resultValue;
    }

    if (PlessViewUtilsSub.isEmptyArray(this.restrictArray) && !this.fullOnly && !this.halfOnly) {
      this.refresh(value);
      return;     // 入力制限が無い場合は処理しない
    }
    if (value == null || value === '') {
      this.refresh(value);
      return;     // 入力値が空の場合は処理しない
    }

    // 全角・半角のみ入力可能な場合
    if (this.fullOnly) {
      // 全角のみ入力可能な場合
      const fullValue = PlessViewUtilsSub.halfToFull(value);
      resultIndex -= (value.length - fullValue.length); // "ｶﾞ"→"ガ" など文字数が減った場合はカーソル位置を調整
      resultValue = fullValue;
    } else if (this.halfOnly) {
      // 半角のみ入力可能な場合
      const halfValue = PlessViewUtilsSub.fullToHalf(value);
      resultIndex -= (value.length - halfValue.length); // "ガ"→ "ｶﾞ" など文字数が増えた場合はカーソル位置を調整
      resultValue = halfValue;
    }

    // 入力制限文字がある場合
    if (!PlessViewUtilsSub.isEmptyArray(this.restrictArray)) {
      const valueArray = `${resultValue}`.split('');
      resultValue = '';
      for (let i = Number(0); i < valueArray.length; i++) {
        // 正規表現チェック
        if (valueArray[i].match(this.restrict)) {
          // 入力可能文字だけ残す
          resultValue += valueArray[i];
        } else if (valueArray[i].toUpperCase().match(this.restrict)) {
          // 小文字が入力された場合、大文字が入力可ならば自動的に大文字にする
          resultValue += valueArray[i].toUpperCase();
        } else if (valueArray[i].toLowerCase().match(this.restrict)) {
          // 大文字が入力された場合、子文字が入力可ならば自動的に子文字にする
          resultValue += valueArray[i].toLowerCase();
        } else {
          // 削除した場合はカーソル位置を調整する
          resultIndex--;
        }
      }
    }
    // Shift-jis 範囲で無い文字は、削除する。
    //  第１水準、第２水準のみ許可する。第３水準は許可しない。
      const valueArray = `${resultValue}`.split('');
      resultValue = '';
      for (let i = 0; i < valueArray.length; i++) {
        const kanjiSJIS = Encoding.convert(valueArray[i],'SJIS','AUTO');
        const kanjiSJIScode = Encoding.stringToCode(kanjiSJIS);
        if (!(kanjiSJIS === '?' && valueArray[i] !== '?')) {                       // SJIS 変換可能文字の場合
          if (kanjiSJIScode.length === 2) {                // 2bytes系文字のみ入力可能とする。
            // 文字コードの範囲チェックを行い、範囲内のみ入力可能とする。
            // チェック1 1byte目 81xx～9Fxx または、E0xx～FCxx のみ入力可能範囲チェック
                if (( kanjiSJIScode[0] >=  129 &&              // 1byte目 81xx～9Fxx または、E0xx～EAxx のみ入力可能
                  kanjiSJIScode[0] <=  159 )    ||         // 129 = 0x81 ,  159 = 0x9F
                ( kanjiSJIScode[0] >=  224 &&              // 224 = 0xE0 ,  252 = 0XFC
                  kanjiSJIScode[0] <=  252 ) ) {

              // チェック2 2byte目 xxは、40～7E または 80～FC のみ入力可能範囲チェック
              if (( kanjiSJIScode[1] >=  64 &&             // 2byte目 xxは、40～7E または 80～FC のみ入力可能
                    kanjiSJIScode[1] <=  126 )    ||       //  64 = 0x40 ,  126 = 0x7E
                  ( kanjiSJIScode[1] >=  128 &&            // 128 = 0x80 ,  252 = 0xFC
                    kanjiSJIScode[1] <=  252 ) ) {

                resultValue += valueArray[i];        //入力可能文字のみ応答用に保存する
              }
            }
          } else if (kanjiSJIScode.length === 1) {        // 1バイト系文字は、入力可
            resultValue += valueArray[i];                 //入力可能文字のみ応答用に保存する
          }
        }
      }

    // アルファベット大文字変換フラグがtrueなら大文字に変換する
    if (this.toUpperCase) {
      resultValue = resultValue.toUpperCase();
    }

    // 文字の変換で文字数が増えた場合に入力文字数制限を超えていたら
    // 超えた文字数分末尾からカットする
    const maxLength = this.elementRef.nativeElement.maxLength;
    if (maxLength != null
        && maxLength !== -1
        && maxLength < resultValue.length) {
      resultValue = resultValue.slice(0, maxLength - resultValue.length);
    }

    // 文字を削除した場合は削除後の値を適応
    if (value !== resultValue) {
      this.elementRef.nativeElement.value = resultValue;
      this.elementRef.nativeElement.selectionStart = resultIndex;
      this.elementRef.nativeElement.selectionEnd = resultIndex;
    }

    this.refresh(resultValue);
  }
}
